var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyPhn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 82,
    viewBox: "0 0 63 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 10.1176V1H1V63H19",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16H62V81H24V16Z",
    fill: "#BABFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48V81H24V63.3285",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 68.5,
    r: 3.5,
    fill: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyPhn);
export default __webpack_public_path__ + "static/media/verifyPhn.ee1119a3e5ac1752bb3360ffde199887.svg";
export { ForwardRef as ReactComponent };